// MUST match apps/api/src/common/types/platform.type.ts PLATFORMS — verified
// by a Phase 5 success criterion (grep that asserts set-wise and length-wise
// equality across the two files). Drift between the API enum and the
// dashboard enum surfaces as 400s on the create endpoint with no clear
// UI feedback. Add a 5th platform requires editing BOTH this file and
// apps/api/src/common/types/platform.type.ts, then a coordinated deploy.
export type Platform = 'ios' | 'android' | 'web' | 'harmonyos';
export const PLATFORMS: Platform[] = ['ios', 'android', 'web', 'harmonyos'];

export interface VersionMapping {
  id: string;
  game_id: string;
  platform: Platform;
  min_version: string;
  max_version: string | null;
  base_url: string;
  deprecation_date: string | null;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface CreateVersionMappingInput {
  game_id: string;
  platform: Platform;
  min_version: string;
  max_version?: string | null;
  base_url: string;
  deprecation_date?: string | null;
  is_active?: boolean;
}

// `platform` is INTENTIONALLY NOT in UpdateVersionMappingInput. The global
// API ValidationPipe has `forbidNonWhitelisted: true` (apps/api/src/main.ts:41),
// so PATCH bodies with `platform` return 400 with message
// "property platform should not exist". To change a mapping's platform,
// delete and recreate.
export interface UpdateVersionMappingInput {
  min_version?: string;
  max_version?: string | null;
  base_url?: string;
  deprecation_date?: string | null;
  is_active?: boolean;
}

export interface ListVersionMappingsParams {
  game_id?: string;
  platform?: Platform;
}
